<template>
    <div id="master-detailpage">
        <TabView v-model:activeIndex="activeTab">
            <template v-if="$auth.canView('payment_history/list')">
                <TabPanel>
                    <template #header>
                        <div class=" text-lg font-bold" >
                            Meters Payment History
                        </div>
                    </template>
                    <div>
                        <PaymentHistoryListPage ref="paymentHistoryListPage"  field-name="payment_history.meter_id" :field-value="masterRecord.meter_id" :show-header="true" v-if="pageReady">
                        </PaymentHistoryListPage>
                    </div>
                </TabPanel>
            </template>
        </TabView>
    </div>
</template>
<script setup>
import { watch, computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useApp } from '@/composables/app.js';
import { useAuth } from '@/composables/auth';
import PaymentHistoryListPage from "../payment_history/list.vue";
const props = defineProps({
	isSubPage: {
		type : Boolean,
		default : true,
	},
	scrollIntoView: {
		type : Boolean,
		default : false,
	},
});
const app = useApp();
const auth = useAuth();
const store = useStore();
const masterRecord = computed(() => store.getters['meters/currentRecord']);
const activeTab = ref(0);
const pageReady = ref(true);
//scroll detail page into view
function scrollToDetailPage() {
	if (props.scrollIntoView) {
		const pageElement = document.getElementById('master-detailpage');
		if(pageElement){
			pageElement.scrollIntoView({behavior:'smooth', block:'start'});
		}
	}
}
// pass form data from master to detail
function setDetailPageFormData(){
	const record = masterRecord.value;
	// set  form data
	const payment_historyFormData = { meter_id:record?.meter_id }
	store.commit('payment_history/setFormData', payment_historyFormData);
}
watch(() => masterRecord, (current) => {
		setDetailPageFormData();
		scrollToDetailPage();
	},
	{ deep: true, immediate: true }
);
onMounted(()=>{ 
    scrollToDetailPage();
});
</script>
